import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface KennzahlenDefinitionProps {
    dummy?: any;
}

export interface KennzahlenDefinitionState {
    dummy?: any;
}

export class KennzahlenDefinition extends React.Component<KennzahlenDefinitionProps, KennzahlenDefinitionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render() {

        const customFormatter = (field: string, value: any) => {
            if (field === 'branchen_gewerke_tid') {
               if (+value === -1) {
                return <div style={{color: '#AAA'}}><i>Cluster</i></div>;
               }
            }
            return value;
        };
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_KENNZAHLEN_DEFINTION}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_KENNZAHLEN_DEFINTION)}
                    showColumnsHelp={true}
                    customFormatter={customFormatter}
                />
            </div>
        );
    }
}
